<template>
  <GmapCustomMarker :marker="{ lat: latitude, lng: longitude }">
    <img src="@/assets/images/logo-recycoin.png"/>
  </GmapCustomMarker>
</template>

<script>
  import GmapCustomMarker from 'vue2-gmap-custom-marker';

  export default {
    name: 'station-marker',
    components: {
      GmapCustomMarker,
    },
    props: {
      latitude: {
        type: Number,
        required: true,
      },
      longitude: {
        type: Number,
        required: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/mixins.scss';

  img {
    width: 4em;
    height: 4em;
    border-radius: 2em;
    @include drop-shadow();
  }
</style>
